export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#261C00',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FBB500',
  },
  {
    path: 'M258.304 329.216h177.664c65.536 0 108.544 29.696 108.544 90.624 0 36.864-18.944 63.488-52.224 77.824v1.024c44.544 9.728 68.608 44.544 68.608 94.208 0 57.344-39.936 101.888-134.656 101.888H258.304z m64 153.088h104.448c30.72 0 53.76-17.92 53.76-50.688 0-36.864-18.944-50.176-53.76-50.176h-104.448z m0 160.256h113.152c38.912 0 61.44-20.992 61.44-57.856 0-35.84-22.528-56.32-61.44-56.32h-113.152zM610.56 430.08h54.784v51.2h1.024c6.656-28.16 41.472-58.368 77.312-58.368a138.8288 138.8288 0 0 1 22.016 1.536v56.32c-8.192-1.024-16.896-2.56-25.088-2.56-39.936 0-71.68 32.256-71.68 90.624v125.952H610.56z',
    fill: '#FBB500',
  },
]
